import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("caros_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data.user);
        setTenant(res.data.tenant);
      })
      .catch(() => localStorage.removeItem("caros_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("caros_token", res.data.token);
    setUser(res.data.user);
    setTenant(res.data.tenant);
    return res.data;
  }, []);

  const register = useCallback(async (payload) => {
    const res = await api.post("/auth/register", payload);
    localStorage.setItem("caros_token", res.data.token);
    setUser(res.data.user);
    setTenant(res.data.tenant);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("caros_token");
    setUser(null);
    setTenant(null);
    window.location.href = "/login";
  }, []);

  return <AuthContext.Provider value={{ user, tenant, loading, login, register, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
